// components/SecureRoute.jsx
import React from 'react';
import { Navigate, Route, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useRBAC } from '../hooks/useRBAC';

/**
 * A wrapper for Route that requires authentication and specific roles
 */
const SecureRoute = ({ element, requiredRoles = ["LeadLens AI User"], redirectTo = "/unauthorized", ...rest }) => {
    const { isAuthenticated, isLoading } = useAuth0();
    const { hasRole, isLoading: rolesLoading } = useRBAC(requiredRoles);
    const location = useLocation();

    // Show loading state when checking auth or roles
    if (isLoading || rolesLoading) {
        return <div>Loading access permissions...</div>;
    }

    // If not authenticated, redirect to login
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // If authenticated but doesn't have required roles, redirect to unauthorized page
    if (!hasRole) {
        return <Navigate to={redirectTo} replace />;
    }

    // User is authenticated and has required roles, render the component
    return element;
};

export default SecureRoute;
